package com.mps.asc_app

import androidx.compose.material3.Scaffold
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.mps.asc_app.di.appModule
import com.mps.asc_app.firebase.FirebaseInitializer
import com.mps.asc_app.presentation.MainViewModel
import com.mps.asc_app.ui.components.NavigationHead
import com.mps.asc_app.ui.theme.AscThemeLight
import com.mps.asc_app.util.TodayDate
import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import kotlinx.browser.document
import kotlinx.browser.window
import org.koin.core.context.GlobalContext.startKoin
import org.koin.core.context.GlobalContext.getOrNull
import org.koin.mp.KoinPlatform.getKoin

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    runCatching {
        if (getOrNull() == null) {
            startKoin {
                modules(appModule(
                    httpClientProvider = {
                        HttpClient(Js) {
                            install(ContentNegotiation) {
                                json(Json {
                                    ignoreUnknownKeys = true
                                    isLenient = true
                                })
                            }
                        }
                    },
                    googlePlacesApiKey = "AIzaSyAhg8Q9KJJq5oRWIV790xgT2v47VGSsn4M",
                    todayProvider = {
                        val now = kotlin.js.Date()
                        TodayDate(
                            day = now.getDate(),
                            month = now.getMonth() + 1,
                            year = now.getFullYear()
                        )
                    }
                ))
            }
        }

        FirebaseInitializer.initialize()

        // Statischen HTML-Loader ausblenden, sobald der Kotlin-Bootstrap laeuft.
        document.getElementById("boot-loader")?.remove()

        ComposeViewport {
            AppWeb()
        }
    }.onFailure { e ->
        val message = (e.message ?: "Unbekannter Startfehler").replace("<", "&lt;").replace(">", "&gt;")
        document.body?.innerHTML = """
            <div style="font-family:sans-serif;padding:24px;max-width:760px;margin:0 auto;">
              <h3>App-Start fehlgeschlagen</h3>
              <p>Fehler: $message</p>
              <p>Bitte Seite neu laden. Falls es weiter haengt, Browserdaten fuer localhost loeschen.</p>
              <button id="reloadBtn" style="padding:8px 12px;">Neu laden</button>
            </div>
        """.trimIndent()
        document.getElementById("reloadBtn")?.addEventListener("click", {
            window.location.reload()
        })
    }
}

@Composable
fun AppWeb() {
    val mainViewModel: MainViewModel = getKoin().get()
    val uiState by mainViewModel.uiState.collectAsState()
    AscThemeLight {
        Scaffold(
            containerColor = MaterialTheme.colorScheme.background,
            topBar = {
                NavigationHead(
                    isLoggedIn = uiState.isLoggedIn,
                    isAdmin = uiState.isAdmin,
                    onHomeClick = { mainViewModel.requestGoHome() },
                    onAdminPanelClick = { mainViewModel.requestOpenAdminPanel() },
                    onLogoutClick = { mainViewModel.logout() },
                )
            }
        ) { innerPadding ->
            App(
                mainViewModel = mainViewModel,
                contentPadding = innerPadding
            )
        }
    }

}